
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Header from '../../components/custom/Header';
import { SessionKey, WebUrl, LanguageOption } from "../../util/Constant.js";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  AlertTypes,
  ApiUrl,
  ApiKey
} from "../../util/Constant";
import ApiEngine from '../../util/ApiEngine';
import {
  Modal,
  ModalBody
} from "reactstrap";
import {
  showMessage,
  setDisplayLogin,
} from "../../redux/AppAction.js";
import moment from 'moment';
import { Spinner } from "react-bootstrap";
import { map } from "lodash";
import Slider from "react-slick";
import parse from 'react-html-parser';
import { LazyLoadImage } from 'react-lazy-load-image-component';

/// <summary>
/// Author :
/// </summary>
const SpinWheel = () => {
  const { t } = useTranslation();
  const _history = useHistory();
  var _dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.authState);

  // *******  state and constant area ******* 

  //free spin component
  const [freeSpinCount, setFreeSpinCount] = useState(0);
  const [spinningBool, setSpinningBool] = useState(false);
  const [showWinningText, setShowWinningText] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [countdownPeriod, setCountdownPeriod] = useState(0);
  const [currentRotation, setCurrentRotation] = useState(0);
  const _SECONDS_IN_MS = 1000;
  //const [spinWheelContent, setSpinWheelContent] = useState({
  //  1: "888K",
  //  2: "Vespa",
  //  3: "500",
  //  4: "8.8K",
  //  5: "100",
  //  6: "8K",
  //  7: "Honda C-RV",
  //  8: "8.88M",
  //  9: "iPhone 15",
  //  10: "50",
  //  11: "1K",
  //  12: "200",
  //});

  const [spinWheelContent, setSpinWheelContent] = useState({
    1: "/img/newspinwheel/50.png",
    2: "/img/newspinwheel/100.png",
    3: "/img/newspinwheel/888K.png",
    4: "/img/newspinwheel/1K.png",
    5: "/img/newspinwheel/IPhone17Pro.png",
    6: "/img/newspinwheel/8K.png",
    7: "/img/newspinwheel/BYD.png",
    8: "/img/newspinwheel/8.8K.png",
    9: "/img/newspinwheel/Rolex.png",
    10: "/img/newspinwheel/500.png",
    11: "/img/newspinwheel/8.88M.png",
    12: "/img/newspinwheel/200.png",
  });

  // Prize values mapping
  const [spinWheelContent2] = useState({
    50: 1,
    100: 2,
    888000: 3,
    1000: 4,
    9000000: 5,
    8000: 6,
    10000000: 7,
    8800: 8,
    9500000: 9,
    500: 10,
    8880000: 11,
    200: 12,
  });

  //winner list component
  const [latestWinData, setLatestWinData] = useState([]);
  const [activeTab, setActiveTab] = useState('marquee');
  const [winningList, setWinningList] = useState([]);
  const [winningListTotal, setWinningListTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);

  const DEFAULT_PAGE_SIZE = 10;

  const marqueeRef = useRef(null);
  const scrollContainerRef = useRef(null);

  //winning prize list
  const listSlidesToShow = 2;

  const prizes = [{
    frame_image: "/img/newspinwheel/first_prize_frame.png",
    image: "/img/newspinwheel/first_prize.png",
    name: "BYD Sealion 7"
  },
  {
    frame_image: "/img/newspinwheel/second_prize_frame.png",
    image: "/img/newspinwheel/second_prize.png",
    name: "Rolex Submariner"
  },
  {
    frame_image: "/img/newspinwheel/third_prize_frame.png",
    image: "/img/newspinwheel/third_prize.png",
    name: "iPhone 17 Pro Max"
  },
  {
    frame_image: "/img/newspinwheel/normal_prize_frame.png",
    image: "/img/newspinwheel/normal_prize.png",
    name: "Up to 2.6888M"
  }];

  const listSlider = {
    slidesToShow: listSlidesToShow,
    dots: false,
    arrows: false,
    swipe: true,
    infinite: prizes.length > listSlidesToShow ? true : false,
    swipeToSlide: true,
    // speed: 5000,
    autoplay: true,
    autoplaySpeed: 5000,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
        },
      }
    ],
  };


  // Terms and conditions
  const [title, setTitle] = useState("");
  const [html, setHtml] = useState("");

  // Callbacks
  const getLatestWinData = useCallback(async () => {
    try {
      const latestWinJson = await ApiEngine.get(ApiUrl._API_GET_LATEST_SPIN_WHEEL_WINNING_RECORD);
      if (latestWinJson[ApiKey._API_SUCCESS_KEY]) {
        const data = latestWinJson[ApiKey._API_DATA_KEY];
        setLatestWinData(data);
      }
    } catch (error) {
      console.error("Error fetching latest win data:", error);
    }
  }, []);

  const lowerCaseAndDeleteLastChar = useCallback((str) => str.toLowerCase().slice(0, -1), []);

  // Effects
  useEffect(() => {
    if (isLoggedIn) {
      checkMemberHasFreeSpin();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (countdownPeriod > 0) {
      setTimeout(() => {
        setCountdownPeriod(countdownPeriod - 1);
      }, _SECONDS_IN_MS);
    }
  }, [countdownPeriod]);

  useEffect(() => {
    getLatestWinData();
  }, [getLatestWinData]);

  useEffect(() => {
    if (isLoggedIn && activeTab === 'list') {
      getSpinWheelWinningRecord(true);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (latestWinData.length > 0 && marqueeRef.current && activeTab === 'marquee') {
      const marqueeElement = marqueeRef.current;
      const totalHeight = marqueeElement.scrollHeight / 2;
      let animationFrameId;
      let start;

      const step = (timestamp) => {
        if (start === undefined) {
          start = timestamp;
        }
        const elapsed = timestamp - start;
        const yPos = (elapsed * 0.025) % totalHeight;
        marqueeElement.style.transform = `translateY(-${yPos}px)`;

        if (yPos >= totalHeight - 1) {
          start = timestamp;
        }

        animationFrameId = requestAnimationFrame(step);
      };

      animationFrameId = requestAnimationFrame(step);

      return () => {
        cancelAnimationFrame(animationFrameId);
        marqueeElement.style.transform = 'translateY(0)';
      }
    }
  }, [latestWinData, activeTab]);

  useEffect(() => {
    getTnc();
  }, [localStorage.getItem(SessionKey._LANGUAGE)]);

  // Functions
  const checkMemberHasFreeSpin = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_CHECK_FREE_SPIN_COUNT);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      setFreeSpinCount(data > 0 ? data : 0);
    } else {
      setFreeSpinCount(0);
    }
  }

  const handleConfirmOnClick = async () => {
    setShowWinningText(false);
    getWinningRecordAfterSpin();
    if (freeSpinCount === 0) {
      setCurrentRotation(0);
    }
  }

  const handleSpinOnClick = async () => {
    if (isLoggedIn) {
      const box = document.getElementById("box");
      const element = document.getElementById("mainbox");

      if (spinningBool) return false;

      setSpinningBool(true);

      let creditResponse = await ApiEngine.get(ApiUrl._API_GET_CHECK_FREE_SPIN_COUNT);
      if (creditResponse[ApiKey._API_SUCCESS_KEY]) {
        let data = creditResponse[ApiKey._API_DATA_KEY];
        if (data != null && data > 0) {
          var responseJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_SPIN_WHEEL);

          if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            deductMemberFreeSpin();
            var index = -1;
            setSelectedItem(responseJson[ApiKey._API_DATA_KEY]);
            console.log("responseJson[ApiKey._API_DATA_KEY]", responseJson[ApiKey._API_DATA_KEY]);
            Object.keys(spinWheelContent2).forEach((key, i) => {
              if (key == responseJson[ApiKey._API_DATA_KEY]) {

                index = spinWheelContent2[key] - 1;
                console.log("index", index);
              }
            });

            let value1 = shuffle([1890, 2250, 2610]);
            let value2 = shuffle([1850, 2230, 2580]);
            let value3 = shuffle([1820, 2180, 2545]);
            let value4 = shuffle([1790, 2160, 2510]);
            let value5 = shuffle([1770, 2120, 2490]);
            let value6 = shuffle([1740, 2110, 2455]);
            let value7 = shuffle([1710, 2080, 2435]);
            let value8 = shuffle([1670, 2040, 2410]);
            let value9 = shuffle([1280, 1285, 2380]);
            let value10 = shuffle([1250, 1255, 2350]);
            let value11 = shuffle([1220, 1225, 2320]);
            let value12 = shuffle([1190, 1195, 2290]);

            var result = "";
            const values = [value1, value2, value3, value4, value5, value6, value7, value8, value9, value10, value11, value12];
            if (index >= 0 && index < 12) {
              result = values[index][0];
            }

            if (countdownPeriod === 0) {
              box.style.setProperty("transition", "all ease 5s");
              const newRotation = (currentRotation - (currentRotation % 360) + result) - 90;
              box.style.transform = "rotate(" + newRotation + "deg)";
              element.classList.remove("animate");
              setCurrentRotation(newRotation);

              setTimeout(function () {
                element.classList.add("animate");
              }, 5000);

              setTimeout(function () {
                setSpinningBool(false);
                setShowWinningText(true)
              }, 6000);

              setCountdownPeriod(6);
            }
          } else {
            _dispatch(
              showMessage({
                type: AlertTypes._ERROR,
                content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
              })
            );
            setSpinningBool(false);
          }
        } else {
          _dispatch(
            showMessage({
              type: AlertTypes._ERROR,
              content: t("DEPOSIT_FOR_FREE_SPIN"),
            })
          );
          setSpinningBool(false);
        }
      } else {
        _dispatch(
          showMessage({
            type: AlertTypes._ERROR,
            content: t(creditResponse[ApiKey._API_MESSAGE_KEY]),
          })
        );
        setSpinningBool(false);
      }
    } else {
      _dispatch(
        showMessage({
          type: AlertTypes._INFO,
          content: t("PLEASE_LOGIN_FIRST"),
        })
      );
    }
  }

  const deductMemberFreeSpin = async () => {
    if (freeSpinCount > 0) {
      setFreeSpinCount(freeSpinCount - 1)
    }
  }

  function shuffle(array) {
    var currentIndex = array.length, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
  }

  const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const renderItems = () => (
    [...latestWinData, ...latestWinData].map((item, index) => (
      <div key={index} className="winner-list-item">
        <div className="winner-list-content">
          <div className="winner-list-username">
            <img
              className="mr-2"
              src={encodeURI(`https://cdn.i8global.com/i8app/${lowerCaseAndDeleteLastChar(item.point_country)}-circle.png`)}
              alt={item.point_country}
            />
            {item.point_username}
          </div>

        </div>
        <div className="winner-list-content">
          <div className="winner-list-datetime">
            {moment(item.point_date).format("DD/MM/YY HH:mm")}</div>
          <div className="winner-list-amount">
            {numberWithCommas(parseFloat(item.point_amount).toFixed(0)) + " " + t("POINTS")}
          </div>
        </div>

      </div>
    ))
  );


  const getSpinWheelWinningRecord = async (isReload = false) => {
    if (isLoggedIn) {
      if (!isLoading) {
        setIsLoading(true);
        var currentPage = page;
        if (isReload) {
          setWinningList([]);
          currentPage = 0;
        } else {
          currentPage += 1;
        }

        setPage(currentPage);

        let responseJson = await ApiEngine.get(`${ApiUrl._API_GET_SPIN_WHEEL_WINNING_RECORD}?start=${(currentPage) * DEFAULT_PAGE_SIZE}&count=${DEFAULT_PAGE_SIZE}`);
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
          let data = responseJson[ApiKey._API_DATA_KEY];
          if (data != null && data['dataList'] != null && data['dataList'].length > 0) {
            if (isReload) {
              setWinningList(data['dataList']);
            } else {
              setWinningList([...winningList, ...data['dataList']]);
            }
            setWinningListTotal(data['totalCount']);
          }
        }
        setIsLoading(false);
      }
    }
  }

  const getWinningRecordAfterSpin = async () => {
    if (isLoggedIn && !isLoading && activeTab === 'list') {
      setIsLoading(true);
      let responseJson = await ApiEngine.get(`${ApiUrl._API_GET_SPIN_WHEEL_WINNING_RECORD}?start=0&count=${DEFAULT_PAGE_SIZE}`);
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        let data = responseJson[ApiKey._API_DATA_KEY];
        if (data != null && data['dataList'] != null && data['dataList'].length > 0) {
          setWinningList(data['dataList']);
          setWinningListTotal(data['totalCount']);
          scrollContainerRef.current.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
          addShiningAnimation();
        }
      }
      setIsLoading(false);
    }
  }

  const addShiningAnimation = () => {
    const firstItem = document.querySelector('.list-content .winner-list-item:first-child');
    if (firstItem) {
      firstItem.classList.add('shine-animation');
      setTimeout(() => {
        firstItem.classList.remove('shine-animation');
      }, 5000);
    }
  }

  const getTnc = async () => {
    let apiUrl = ApiUrl._API_GET_COMPANY_CONTENT + "?page=spin-wheel-tnc";

    if (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) !== 'undefined') {
      if (LanguageOption.find((x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)) !== undefined) {
        apiUrl += "&languageId=" + LanguageOption.find((x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)).languageId;
      } else {
        apiUrl += "&languageId=1";
      }
    } else {
      apiUrl += "&languageId=1";
    }

    var responseJson = await ApiEngine.get(apiUrl);

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      const title = responseJson[ApiKey._API_DATA_KEY][0]["title"];
      const content = responseJson[ApiKey._API_DATA_KEY][0]["content"];
      setHtml(content);
      setTitle(title);
    }
  }

  const renderStars = (count) => {
    return Array(count).fill(0).map((_, i) => (
      <span key={i} className="prize-star">★</span>
    ));
  }

  return (
    <>
      <Header
        history={_history}
        url={WebUrl._URL_MAIN}
        title={t("LUCKY_SPIN")}
        hasBackButton={true}
      />
      <div className="spin-wheel-section" style={{ cursor: 'pointer' }} onClick={() => !spinningBool ? handleSpinOnClick() : false}>
        <div className="spin-wheel-wrapper" id="mainbox">
          

          {/* Rotating Wheel Body */}
          <div className="spin-wheel-body" id="box">
            <img src="/img/newspinwheel/body1.png" alt="wheel" className="wheel-base" />
            {Object.keys(spinWheelContent).map((key, index) => {
              const itemCount = Object.keys(spinWheelContent).length;
              let angleDeg = 105;
              let abgleTranlateX = 60;
              if (window.innerWidth <= 350) { angleDeg = 110; abgleTranlateX = 30; }
              if (window.innerWidth <= 390) { angleDeg = 107; abgleTranlateX = 45; }

              const angle = (index * (360 / itemCount)) - angleDeg;

              return (
                <div
                  key={index}
                  className="wheel-reward-item"
                  style={{
                    transform: `rotate(${angle}deg)`,
                    position: 'absolute',
                    top: '50%',
                    left: `50%`,
                    transformOrigin: 'center center', // Changed from 'center center'
                  }}
                >
                  <div
                    className="reward-content"
                    style={{
                      transform: `translateX(${abgleTranlateX}px) rotate(${-angle}deg)`
                    }}
                  >
                    <img src={spinWheelContent[key]} alt={`prize-${key}`} />
                  </div>
                </div>
              )
            })}
          </div>

          {/* Wheel Ring/Frame */}
          <div className="spin-wheel-ring">
            <img src="/img/newspinwheel/ring.png" alt="ring" />
          </div>

          {/* Center Logo (i8 logo) */}
          <div className="spin-wheel-center">
            <img src="/img/newspinwheel/center.png" alt="center" className="center-logo" />
          </div>

          {/* Blue Ball with Count - Above Button */}
          <div className="spin-count-ball">
            <span className="count-ball-number">{freeSpinCount}</span>
          </div>
        </div>
      </div>


      <h3 style={{ marginTop: "30px" }} >{t("WINNING_PRIZES")}</h3>
      <div className="spin-wheel-prize-slider">
        <Slider {...listSlider}>
          {prizes &&
            prizes.length &&
            map(prizes, (item, index) => {
              return (
                <div key={index} className="spin-wheel-prize-slider-item">
                  <div className="frame-container">
                    <img
                      src={item.frame_image}
                      className="frame-image"
                      alt={`${item.name} frame`}
                      loading="lazy"
                    />
                    <div className="image-container">
                      <img
                        src={item.image}
                        className="prize-image"
                        alt={item.name}
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </Slider>
      </div>
      <hr className="hr-left" />
      <div className="spin-wheel-winner-list-container">
        <div className="frame-background" style={{ backgroundImage: `url("/img/newspinwheel/winner_frame.png")` }}>
          <div className="tab-header">
            <button onClick={() => setActiveTab('marquee')} className={`tab-button ${activeTab === 'marquee' ? 'active' : ''}`}>
              {t("WINNER_LIST")}
            </button>
            <button onClick={() => {
              setActiveTab('list');
              getSpinWheelWinningRecord(true);
            }} className={`tab-button ${activeTab === 'list' ? 'active' : ''}`}>
              {t("WINNER_RECORD")}
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'marquee' ? (
              <div className="marquee-container">
                <div ref={marqueeRef} className="marquee-content">
                  {renderItems()}
                </div>
              </div>
            ) : (
              <div className="list-container" ref={scrollContainerRef}>
                <div className="list-content">
                  {isLoggedIn ? (
                    <>
                      {
                        winningList.length > 0 &&
                        winningList.map((item, index) => (
                          <div key={index} className="winner-list-item">
                            <div className="winner-list-content">
                              <div className="winner-list-datetime">
                                {moment(item.createdTime).format("DD/MM/YY HH:mm")}</div>
                            </div>
                            <div className="winner-list-content">
                              <div className="winner-list-amount">
                                {numberWithCommas(parseFloat(item.points).toFixed(0)) + " " + t("POINTS")}
                              </div>
                            </div>
                          </div>
                        ))
                      }

                      {!isLoading && winningList <= 0 &&
                        <div>
                          {t("RECORD_NOT_FOUND")}
                        </div>
                      }

                      {isLoading &&
                        <Spinner animation="border"
                          role="status"
                          size="sm"
                          style={{ verticalAlign: "middle", marginLeft: "10px" }}>
                          <span className="sr-only">{t("LOADING")}...</span>
                        </Spinner>
                      }

                      {winningListTotal > winningList.length && !isLoading &&
                        <div className="winner-list-view-more" onClick={() => { getSpinWheelWinningRecord() }}>
                          {t('VIEW_MORE')}
                        </div>
                      }
                    </>
                  )
                    :
                    <div className="spin-wheel-aut-error-message">
                      {t("PLEASE_LOGIN_FIRST")}
                    </div>
                  }
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="spin-wheel-tnc-container">
        <h3 className="mb-4">{t(title)}</h3>
        <div className="spin-wheel-tnc-content">
          {parse(html)}
        </div>
        <div className="spin-wheel-tnc-image">
          <LazyLoadImage
            src={"/img/newspinwheel/tnc_image.png"}
            className="img-100 w-full h-full object-cover"
            alt="banner"
          />
        </div>
      </div>
      <Modal
        isOpen={showWinningText}
        contentClassName="spinwheel-winning-popup"
        id="success-modal"
        fade={true}
        toggle={() => {
          handleConfirmOnClick();
        }}
        centered
      >
        <ModalBody>
          <div className="spinwheel-winning-popup-body">
            <div className="spinwheel-winning-text">
              <div>{t("SPIN_WHEEL_SUCCESS", { value: selectedItem }) + (typeof selectedItem === 'number' ? " " + t("POINTS") + "." : ".")}</div>
            </div>
            <button className="btn btn-lg btn-primary w-100 mt-4" onClick={() => handleConfirmOnClick()}>{t("CONFIRM")}</button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SpinWheel;
